module.exports = __webpack_public_path__ + "img/result-01.c507c4cc.svg";